/*
 * @Author: 王文龙
 * @Date: 2024-01-11 16:40:55
 * @Description: 信息脱敏查询、编辑接口拆分
 * @LastEditTime: 2025-04-03 10:07:20
 */
export const INTERFACE_SPLITS = {
	// 扶摇用户详情接口拆分
	USER_DETAIL: {
		view: '/admin/v1/users',
		edit: '/admin/v1/users/detail_edit'
	},
	// 人脸识别详情接口拆分
	FACE_DETAIL: {
		view: '/admin/dcms/v1/face/record/detail',
		edit: '/admin/dcms/v1/face/record/edit_detail'
	},
	// 司机详情接口拆分
	DRIVER_DETAIL: {
		view: '/admin/v1/drivers',
		edit: '/admin/v1/drivers/driver_edit_detail'
	},
	// 工单信息详情接口拆分
	WORK_ORDER_DETAIL: {
		view: '/admin/v1/workOrderInfo/getWorkOrderSafeInfoById',
		edit: '/admin/v1/workOrderInfo/getById'
	},
	// 订单所有司机信息接口拆分
	ORDER_ALL_DRIVER: {
		view: '/admin/v1/workOrderInfo/querySafeOrderDriverList',
		edit: '/admin/v1/workOrderInfo/queryOrderDriverList'
	},
	// 信息变更详情接口拆分
	INFO_CHANGE_DETAIL: {
		view: '/admin/dcms/v1/changes/audit/detail',
		edit: '/admin/dcms/v1/changes/audit/audit_detail'
	},
	// 信息变更质检详情接口拆分
	INFO_CHANGE_QUALITY_DETAIL: {
		view: '/admin/dcms/v1/changes/quality/show_detail',
		edit: '/admin/dcms/v1/changes/quality/audit_detail'
	},
	// 车辆详情接口拆分
	CAR_DETAIL: {
		view: '/admin/v1/cars',
		edit: '/admin/v1/cars_edit_detail'
	},
	// 验车视频详情接口拆分
	EXTRA_DETAIL: {
		view: '/admin/dcms/v1/driver/extra/info',
		edit: '/admin/dcms/v1/driver/extra/edit_info'
	},
	// 无犯罪记录审核详情接口拆分
	NO_CRIME_DETAIL: {
		view: '/admin/dcms/v1/driver/no_crime/info',
		edit: '/admin/dcms/v1/driver/no_crime/edit_info'
	},
	// 验真与合规资料审核、验真与合规资料详情接口拆分
	NET_CERT_DETAIL: {
		view: '/admin/dcms/v1/netCert/detail',
		edit: '/admin/dcms/v1/netCert/edit_detail'
	},
	// 账号找回详情接口拆分
	CHANGE_RECORD_DETAIL: {
		view: '/admin/v1/tasks/applyIdChangeRecord/get',
		edit: '/admin/v1/tasks/applyIdChangeRecord/edit_detail'
	},
	// 招募审核详情接口拆分
	RECRUIT_DETAIL: {
		view: '/admin/dcms/v1/recruit/detail',
		edit: '/admin/dcms/v1/recruit/edit_detail'
	},
	// 换车审核详情接口拆分
	CHANGE_CAR_DETAIL: {
		view: '/admin/dcms/v1/changeCar/detail',
		edit: '/admin/dcms/v1/changeCar/edit_detail'
	},
	// 招募质检详情接口拆分
	RECRUIT_QUALITY_DETAIL: {
		view: '/admin/dcms/v1/quality/detail',
		edit: '/admin/dcms/v1/quality/edit_detail'
	},
	// 换车质检详情接口拆分
	CHANGE_CAR_QUALITY_DETAIL: {
		view: '/admin/dcms/v1/changeCar/quality_show_detail',
		edit: '/admin/dcms/v1/changeCar/quality_detail'
	},
	// 车辆与车贴抽检详情接口拆分
	CAR_INSPECT_RECORD_DETAIL: {
		view: '/admin/dcms/v1/car_inspect/record/detail',
		edit: '/admin/dcms/v1/car_inspect/record/edit_detail'
	},
	// 车队详情接口拆分
	COMPANY_DETAIL: {
		view: '/admin/v1/company/info',
		edit: '/admin/v1/company/edit_info'
	},
	// 电子驾驶证审核详情接口拆分
	ELECTRONIC_DRIVER_LICENSE_DETAIL: {
		view: '/admin/dcms/v1/driver/electron/info',
		edit: '/admin/dcms/v1/driver/electron/edit_info'
	}
}
